module.exports = __webpack_public_path__ + "images/emoji/white_small_square.79d8586aec16ba527b39.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/white_small_square.png
// module id = LPBU
// module chunks = 1